export default __webpack_public_path__ + "static/media/NI.dba1b74e.svg";